import React from "react";

const FilterIcon = ({ fill = "#919293", height = "20", width = "20" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.08179 3.91543C3.08179 3.7743 3.13785 3.63894 3.23765 3.53914C3.33745 3.43934 3.47281 3.38327 3.61395 3.38327H16.3859C16.527 3.38327 16.6624 3.43934 16.7622 3.53914C16.862 3.63894 16.9181 3.7743 16.9181 3.91543V6.04409C16.918 6.17533 16.8695 6.30193 16.7818 6.39958L12.1286 11.5701V16.6874C12.1285 16.799 12.0933 16.9078 12.028 16.9983C11.9626 17.0889 11.8705 17.1566 11.7646 17.1919L8.57159 18.2562C8.49163 18.2828 8.40649 18.2901 8.32318 18.2774C8.23986 18.2647 8.16076 18.2323 8.09238 18.1831C8.02399 18.1338 7.96829 18.069 7.92985 17.994C7.89141 17.919 7.87133 17.836 7.87126 17.7517V11.5701L3.21802 6.39958C3.13033 6.30193 3.08181 6.17533 3.08179 6.04409V3.91543ZM4.14612 4.4476V5.83974L8.79936 11.0102C8.88705 11.1079 8.93557 11.2345 8.93559 11.3657V17.0131L11.0642 16.3042V11.3657C11.0643 11.2345 11.1128 11.1079 11.2005 11.0102L15.8537 5.83974V4.4476H4.14612Z"
      fill={fill}
    />
  </svg>
);

export default FilterIcon;
